export const handleSalesOrderWorkspaceMutationCommitted = async ({
  source,
  mutationType,
  unlocked,
  updateMode,
  nextPayload,
  orderId,
  salesOrderId,
  regenerateSalesOrderFromCart,
  resetDirty,
  refreshOrder,
}) => {
  if (source !== "sales-order-cart" || !unlocked) {
    return { handled: false, regenerated: false };
  }

  if (updateMode !== "automatic") {
    return { handled: true, regenerated: false };
  }

  if (!nextPayload) {
    return { handled: true, regenerated: false, error: "missing-payload" };
  }

  try {
    await regenerateSalesOrderFromCart(orderId, salesOrderId, {
    source: "sales-order-cart",
    payload: nextPayload,
    approvalMode: "preserve",
    regenerateReason: `sales-order-cart-${mutationType}`,
    });
  } catch (error) {
    // A decoration-routing failure on another item must not turn an already
    // committed Edit Item save into a failed save. Keep the workspace dirty:
    // the approved document snapshot has NOT been regenerated.
    const code = error?.response?.data?.code;
    if (mutationType === "edit-product" && (
      code === "DECORATOR_ROUTING_REQUIRED" ||
      code === "DECORATOR_ROUTING_AMBIGUOUS"
    )) {
      return { handled: true, regenerated: false, pendingRegeneration: true, error: code };
    }
    throw error;
  }
  resetDirty?.();
  await refreshOrder?.({ suppressLoader: true });

  return { handled: true, regenerated: true };
};
